export const modalConstants = {
  TOGGLE_MODAL_GENERAL: 'TOGGLE_MODAL_GENERAL',
  TOGGLE_MODAL_ACCEPT: 'TOGGLE_MODAL_ACCEPT',
  TOGGLE_MODAL_AGE: 'TOGGLE_MODAL_AGE',
  TOGGLE_MODAL_CONFIRM_AGE: 'TOGGLE_MODAL_CONFIRM_AGE',
  TOGGLE_MODAL_UPDATE: 'TOGGLE_MODAL_UPDATE',
  TOGGLE_MODAL_FAVORITE: 'TOGGLE_MODAL_FAVORITE'
};
